import { render, staticRenderFns } from "./ProtocolSmall.vue?vue&type=template&id=2d01ef72&"
import script from "./ProtocolSmall.vue?vue&type=script&lang=js&"
export * from "./ProtocolSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports